<script setup lang="ts">
    import type { DiscreteScaleLevel } from '@Scales/Model'

    // ---------------- props / emits ----------------

    const props = defineProps<{
        Comment: string | null
        Value: number | null
        HasAnswer: boolean
        HasScale: boolean
        ScaleLevels: DiscreteScaleLevel[] | null
    }>()

    const emit = defineEmits<{
        (e: 'update-comment', comment: string | null): void
        (e: 'update-value', value: number | null): void
    }>()

    // ---------------- actions ----------------

    function setComment(comment: string | null)
    {
        emit('update-comment', comment)
    }

    function setDirectValue(val: any)
    {
        const value = parseFloat(val)
        emit('update-value', value)
    }

    function setScaleValue(sl: DiscreteScaleLevel)
    {
        const value = isSelected(sl) ? null : sl.Value
        emit('update-value', value)
    }

    function isSelected(sl: DiscreteScaleLevel): boolean
    {
        return props.Value === sl.Value
    }
</script>


<template>
    <div>
        <div v-if="HasScale">
            <div class="list-group">
                <button v-for="sl in ScaleLevels" @click="setScaleValue(sl)"
                        class="list-group-item list-group-item-action text-left" :class="{'active': isSelected(sl)}">

                    <i class="fa" :class="[isSelected(sl) ? 'fa-check-circle' : 'fa-circle-thin' ]"></i> {{sl.Name}} ({{sl.Value}})

                    <p v-if="sl.Definition" class="mb-0">{{sl.Definition}}</p>
                </button>
            </div>
            <textarea rows="3" :value.trim="Comment" @input="setComment($event.target.value)" class="form-control my-3" placeholder="Comment..."></textarea>

            <button v-if="!HasAnswer" type="button" class="btn btn-secondary" @click="setComment('Skipped')">
                Skip (don't guess)
            </button>
        </div>

        <div v-if="!HasScale">
            <input type="number" :value="Value" @input="setDirectValue($event.target.value)" class="form-control" />
            <textarea rows="3" :value.trim="Comment" @input="setComment($event.target.value)" class="form-control my-3" placeholder="Comment..."></textarea>

            <button v-if="!HasAnswer" type="button" class="btn btn-secondary" @click="setComment('Skipped')">
                Skip (don't guess)
            </button>
        </div>
    </div>
</template>